import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { WalletProvider } from './context/WalletContext';
import { ContractProvider } from './context/ContractContext';
import { NotificationProvider } from './context/NotificationContext';
import ToastContainer from './components/notifications/ToastContainer/ToastContainer';

// Pages
import Welcome from './pages/Welcome/Welcome';
import Landing from './pages/Landing/Landing';
import Dashboard from './pages/Dashboard/Dashboard';
import Register from './pages/Register/Register';
import Invest from './pages/Invest/Invest';
import Withdraw from './pages/Withdraw/Withdraw';
import Team from './pages/Team/Team';
import Activity from './pages/Activity/Activity';
import Profile from './pages/Profile/Profile';
import Admin from './pages/Admin/Admin';

// Styles
import './styles/reset.css';
import './styles/variables.css';
import './styles/global.css';
import './styles/animations.css';
import './styles/utilities.css';
import './App.css';

function App() {
  const [showWelcome, setShowWelcome] = useState(true);

  useEffect(() => {
    const welcomed = localStorage.getItem('gainforce_welcomed');
    if (welcomed === 'true') {
      setShowWelcome(false);
    }
  }, []);

  return (
    <NotificationProvider>
      <WalletProvider>
        <ContractProvider>
          <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <div className="app">
              <Routes>
                <Route path="/welcome" element={<Welcome />} />
                <Route path="/" element={showWelcome ? <Navigate to="/welcome" replace /> : <Landing />} />
                <Route path="/home" element={<Landing />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/register" element={<Register />} />
                <Route path="/invest" element={<Invest />} />
                <Route path="/withdraw" element={<Withdraw />} />
                <Route path="/team" element={<Team />} />
                <Route path="/activity" element={<Activity />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
              <ToastContainer />
            </div>
          </Router>
        </ContractProvider>
      </WalletProvider>
    </NotificationProvider>
  );
}

export default App;
